// const server = "/api/v1";
const server = "https://urbanbazaarpune.in/api/v1"; //"http://localhost:8000/api/v1"; //"http://localhost:8000/api/v1";
//keep server /api/v1 in build
//keeop server http://localhost:8000/api/v1 in development
export const EstoreBaseUrl = "https://estore.searchintech.in/api/v1";
export default server;
